import Image from 'next/image';

import { Section } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';

const OurPromise = () => (
  <Section>
    <div className='relative rounded-2xl overflow-hidden shadow-lg'>
      <div className='absolute inset-0 w-full h-full'>
        <Image
          alt='Two hands holding a heart shape'
          className='opacity-90'
          fill
          style={{ objectFit: 'cover' }}
          src={`${staticMediaStoreBaseURL}/about-hafla/our-promise/our-promise-background.png`}
        />
      </div>

      <div className='relative flex flex-col items-center justify-center text-center text-white font-Montserrat w-full h-full px-4 py-16 sm:py-24 md:py-28'>
        <div className='text-4xl md:text-5xl font-extrabold mb-4'>
          Our Promise
        </div>
        <div className='max-w-4xl text-base sm:text-lg leading-relaxed font-bold'>
          Hafla brings clarity, creativity, and control—so your event feels
          effortless, and your audience feels something they'll remember.
          “Smart. Fast. Awesome” is our brand promise.
        </div>
      </div>
    </div>
  </Section>
);

export default OurPromise;
